import { API } from './API.js';
import axios from 'axios';

const url = API + '/translate';
const debug = false;

// Allowed languages on client side (guardrail)
const SUPPORTED_LANGUAGES = ['en', 'de', 'fr', 'es', 'it', 'nl', 'pt'];

class Translate {

  /**
   * Generic translate with auto-detect
   * POST /api/translate
   * body:
   * {
   *   text: string,
   *   target: 'en'|'de'|'fr'|'es'|'it'|'nl'|'pt',
   *   tone?: string
   * }
   *
   * Returns:
   * {
   *   sourceLanguage,
   *   targetLanguage,
   *   translatedText,
   *   wasTranslated
   * }
   */
  static translate(postdata) {
    if (!postdata?.text || typeof postdata.text !== 'string') {
      console.error('Translate.translate: missing or invalid text');
      return Promise.reject('Invalid text');
    }

    if (!SUPPORTED_LANGUAGES.includes(postdata.target)) {
      console.error('Translate.translate: unsupported target language', postdata.target);
      return Promise.reject('Unsupported language');
    }

    return axios.post(url, postdata)
      .then(response => {
        if (debug) console.log('Translate.translate:', response.data);
        return response.data;
      })
      .catch(error => {
        console.log('Translate.translate error:', error);
        throw error;
      });
  }

  /**
   * Convenience wrappers
   */
  static toFrench(text, tone = 'natural') {
    return Translate.translate({ text, target: 'fr', tone });
  }

  static toEnglish(text, tone = 'natural') {
    return Translate.translate({ text, target: 'en', tone });
  }

  static toGerman(text, tone = 'natural') {
    return Translate.translate({ text, target: 'de', tone });
  }

  static toSpanish(text, tone = 'natural') {
    return Translate.translate({ text, target: 'es', tone });
  }

  static toItalian(text, tone = 'natural') {
    return Translate.translate({ text, target: 'it', tone });
  }

  static toDutch(text, tone = 'natural') {
    return Translate.translate({ text, target: 'nl', tone });
  }

  static toPortuguese(text, tone = 'natural') {
    return Translate.translate({ text, target: 'pt', tone });
  }
}

export default Translate;